exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.thumbnail[data-v-5c135336] {\n    cursor: pointer;\n}\n", ""]);

// exports
